export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	venusaur: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			ingrain: ["9M"],
			knockoff: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			outrage: ["9M"],
			petalblizzard: ["9M"],
			petaldance: ["9M"],
			poisonjab: ["9M"],
			poisonpowder: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			roar: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetscent: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			terrainpulse: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			weatherball: ["9M"],
			worryseed: ["9M"],
		},
	},
	charizard: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			ancientpower: ["9M"],
			beatup: ["9M"],
			bellydrum: ["9M"],
			bite: ["9M"],
			blastburn: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			inferno: ["9M"],
			irontail: ["9M"],
			megakick: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			temperflare: ["9M"],
			thunderpunch: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
		},
	},
	blastoise: {
		learnset: {
			aquajet: ["9M"],
			aquaring: ["9M"],
			aquatail: ["9M"],
			aurasphere: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bulldoze: ["9M"],
			brickbreak: ["9M"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lifedew: ["9M"],
			liquidation: ["9M"],
			megakick: ["9M"],
			mirrorcoat: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shellsmash: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			terrainpulse: ["9M"],
			waterpulse: ["9M"],
			waterspout: ["9M"],
			waterfall: ["9M"],
			wavecrash: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	beedrill: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			crosspoison: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			dualwingbeat: ["9M"],
			electroweb: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fellstinger: ["9M"],
			focusenergy: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			lunge: ["9M"],
			payback: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			pollenpuff: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			screech: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stringshot: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			uturn: ["9M"],
			venoshock: ["9M"],
			xscissor: ["9M"],
		},
	},
	pidgeot: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9M"],
			attract: ["9M"],
			bravebird: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			quickattack: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			whirlwind: ["9M"],
		},
	},
	arbok: {
		learnset: {
			acidspray: ["9M"],
			beatup: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			coil: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gastroacid: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			leechlife: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			poisonfang: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spitup: ["9M"],
			spite: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swallow: ["9M"],
			switcheroo: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			wrap: ["9M"],
		},
	},
	pikachu: {
		learnset: {
			agility: ["9M"],
			alluringvoice: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focuspunch: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			nuzzle: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			sweetkiss: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9M"],
			wildcharge: ["9M"],
			wish: ["9M"],
			zapcannon: ["9M"],
		},
	},
	raichu: {
		learnset: {
			agility: ["9M"],
			alluringvoice: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			nuzzle: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			sweetkiss: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9M"],
			wildcharge: ["9M"],
			wish: ["9M"],
			zapcannon: ["9M"],
		},
	},
	raichualola: {
		learnset: {
			agility: ["9M"],
			alluringvoice: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			nuzzle: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			speedswap: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			sweetkiss: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			voltswitch: ["9M"],
			volttackle: ["9M"],
			wildcharge: ["9M"],
			wish: ["9M"],
			zapcannon: ["9M"],
		},
	},
	clefable: {
		learnset: {
			afteryou: ["9M"],
			airslash: ["9M"],
			alluringvoice: ["9M"],
			amnesia: ["9M"],
			batonpass: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			cosmicpower: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			dualwingbeat: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			followme: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			healpulse: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			meteorbeam: ["9M"],
			meteormash: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			moonlight: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetkiss: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			wish: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	ninetales: {
		learnset: {
			agility: ["9M"],
			attract: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bodyslam: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			doubleedge: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flail: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			healingwish: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			imprison: ["9M"],
			inferno: ["9M"],
			irontail: ["9M"],
			memento: ["9M"],
			mysticalfire: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			overheat: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tailslap: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	ninetalesalola: {
		learnset: {
			agility: ["9M"],
			attract: ["9M"],
			auroraveil: ["9M"],
			avalanche: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			doubleedge: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			foulplay: ["9M"],
			freezedry: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icebeam: ["9M"],
			iceshard: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irontail: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			nastyplot: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			tailslap: ["9M"],
			tripleaxel: ["9M"],
			weatherball: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	arcanine: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			burnup: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			covet: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			extremespeed: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			morningsun: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			ragingfury: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			thunderfang: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
		},
	},
	arcaninehisui: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			burnup: ["9M"],
			closecombat: ["9M"],
			covet: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			extremespeed: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			morningsun: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			ragingfury: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			smartstrike: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			thunderfang: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
		},
	},
	alakazam: {
		learnset: {
			allyswitch: ["9M"],
			attract: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			dazzlinggleam: ["9M"],
			disable: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			guardsplit: ["9M"],
			guardswap: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			imprison: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psychocut: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			speedswap: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	machamp: {
		learnset: {
			assurance: ["9M"],
			attract: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletpunch: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			crosschop: ["9M"],
			crosspoison: ["9M"],
			darkestlariat: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seismictoss: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			tickle: ["9M"],
			wideguard: ["9M"],
		},
	},
	victreebel: {
		learnset: {
			acidspray: ["9M"],
			bodyslam: ["9M"],
			bugbite: ["9M"],
			bulletseed: ["9M"],
			clearsmog: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gastroacid: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			hyperbeam: ["9M"],
			ingrain: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			leechlife: ["9M"],
			lunge: ["9M"],
			poisonjab: ["9M"],
			poisonpowder: ["9M"],
			pounce: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeppowder: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spitup: ["9M"],
			stockpile: ["9M"],
			strengthsap: ["9M"],
			stunspore: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swallow: ["9M"],
			sweetscent: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			thief: ["9M"],
			tickle: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			weatherball: ["9M"],
			worryseed: ["9M"],
			wrap: ["9M"],
		},
	},
	slowbro: {
		learnset: {
			amnesia: ["9M"],
			avalanche: ["9M"],
			belch: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			dive: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nastyplot: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	slowbrogalar: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9M"],
			avalanche: ["9M"],
			belch: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nastyplot: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psychup: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			shellsidearm: ["9M"],
			skillswap: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			venoshock: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gengar: {
		learnset: {
			acidspray: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			clearsmog: ["9M"],
			confuseray: ["9M"],
			corrosivegas: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			meanlook: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			perishsong: ["9M"],
			phantomforce: ["9M"],
			poisonjab: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			raindance: ["9M"],
			reflecttype: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			venoshock: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
		},
	},
	kangaskhan: {
		learnset: {
			assurance: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			beatup: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			circlethrow: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			hammerarm: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandstorm: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			terrainpulse: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
			whirlpool: ["9M"],
		},
	},
	starmie: {
		learnset: {
			agility: ["9M"],
			allyswitch: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bulkup: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			cosmicpower: ["9M"],
			dazzlinggleam: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			gyroball: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			meteorbeam: ["9M"],
			minimize: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychocut: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			recover: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			selfdestruct: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	pinsir: {
		learnset: {
			aerialace: ["9M"],
			attract: ["9M"],
			bind: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bugbite: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			guillotine: ["9M"],
			hardpress: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lunge: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			seismictoss: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			xscissor: ["9M"],
		},
	},
	tauros: {
		learnset: {
			assurance: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			megahorn: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			ragingbull: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			whirlpool: ["9M"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	taurospaldeacombat: {
		learnset: {
			assurance: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			megahorn: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			ragingbull: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	taurospaldeablaze: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			megahorn: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			ragingbull: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	taurospaldeaaqua: {
		learnset: {
			aquajet: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			highhorsepower: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			liquidation: ["9M"],
			megahorn: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			ragingbull: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			wavecrash: ["9M"],
			whirlpool: ["9M"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	gyarados: {
		learnset: {
			aquatail: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			dragoncheer: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flail: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thrash: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
		},
	},
	ditto: {
		learnset: {
			transform: ["9M"],
		},
	},
	vaporeon: {
		learnset: {
			acidarmor: ["9M"],
			alluringvoice: ["9M"],
			aquaring: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			flipturn: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			liquidation: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	jolteon: {
		learnset: {
			agility: ["9M"],
			alluringvoice: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleedge: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			metalsound: ["9M"],
			mudslap: ["9M"],
			pinmissile: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			weatherball: ["9M"],
			wildcharge: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	flareon: {
		learnset: {
			alluringvoice: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flail: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lastresort: ["9M"],
			lavaplume: ["9M"],
			mudslap: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			temperflare: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	aerodactyl: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			ancientpower: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			bite: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dualwingbeat: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			meteorbeam: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			steelwing: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderfang: ["9M"],
			whirlwind: ["9M"],
			wideguard: ["9M"],
		},
	},
	snorlax: {
		learnset: {
			amnesia: ["9M"],
			attract: ["9M"],
			belch: ["9M"],
			bellydrum: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			covet: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gastroacid: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hammerarm: ["9M"],
			hardpress: ["9M"],
			heatcrash: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			lastresort: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			supercellslam: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swallow: ["9M"],
			terrainpulse: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	dragonite: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			aquajet: ["9M"],
			aquatail: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			dive: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			extremespeed: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			steelwing: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			tailwind: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlwind: ["9M"],
			wrap: ["9M"],
		},
	},
	meganium: {
		learnset: {
			ancientpower: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			doubleedge: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			ingrain: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			petalblizzard: ["9M"],
			petaldance: ["9M"],
			poisonpowder: ["9M"],
			pollenpuff: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetscent: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			trailblaze: ["9M"],
			weatherball: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	typhlosion: {
		learnset: {
			aerialace: ["9M"],
			blastburn: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			burnup: ["9M"],
			burningjealousy: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			eruption: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			inferno: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			overheat: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			temperflare: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	typhlosionhisui: {
		learnset: {
			aerialace: ["9M"],
			blastburn: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			burnup: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			eruption: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			heatwave: ["9M"],
			hex: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			infernalparade: ["9M"],
			inferno: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			overheat: ["9M"],
			playrough: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			temperflare: ["9M"],
			thunderpunch: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	feraligatr: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9M"],
			aquatail: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
		},
	},
	ariados: {
		learnset: {
			acidspray: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			crosspoison: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fellstinger: ["9M"],
			firstimpression: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			infestation: ["9M"],
			knockoff: ["9M"],
			leechlife: ["9M"],
			lunge: ["9M"],
			megahorn: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			ragepowder: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowsneak: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			stickyweb: ["9M"],
			stompingtantrum: ["9M"],
			stringshot: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			toxicthread: ["9M"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			xscissor: ["9M"],
		},
	},
	ampharos: {
		learnset: {
			afteryou: ["9M"],
			agility: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			cottonguard: ["9M"],
			cottonspore: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			doubleedge: ["9M"],
			dragoncheer: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			magneticflux: ["9M"],
			megakick: ["9M"],
			meteorbeam: ["9M"],
			outrage: ["9M"],
			paraboliccharge: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			supercellslam: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
			zapcannon: ["9M"],
		},
	},
	azumarill: {
		learnset: {
			alluringvoice: ["9M"],
			amnesia: ["9M"],
			aquajet: ["9M"],
			aquaring: ["9M"],
			aquatail: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			perishsong: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			sing: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
		},
	},
	politoed: {
		learnset: {
			amnesia: ["9M"],
			attract: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			perishsong: ["9M"],
			pound: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
		},
	},
	espeon: {
		learnset: {
			alluringvoice: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			imprison: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			morningsun: ["9M"],
			mudslap: ["9M"],
			powergem: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicfangs: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thunderwave: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			weatherball: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	umbreon: {
		learnset: {
			alluringvoice: ["9M"],
			assurance: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			guardswap: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lashout: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			meanlook: ["9M"],
			moonlight: ["9M"],
			mudslap: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderwave: ["9M"],
			tickle: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			weatherball: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	slowking: {
		learnset: {
			amnesia: ["9M"],
			avalanche: ["9M"],
			belch: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			chillyreception: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			dive: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nastyplot: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	slowkinggalar: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9M"],
			avalanche: ["9M"],
			belch: ["9M"],
			bellydrum: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			chillyreception: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			dive: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			eeriespell: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nastyplot: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stompingtantrum: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			triattack: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			venoshock: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	forretress: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			gyroball: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icespinner: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			lunge: ["9M"],
			magnetrise: ["9M"],
			metalsound: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			pounce: ["9M"],
			powertrick: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelroller: ["9M"],
			stoneedge: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thunderwave: ["9M"],
			toxicspikes: ["9M"],
			venoshock: ["9M"],
			voltswitch: ["9M"],
			zapcannon: ["9M"],
		},
	},
	steelix: {
		learnset: {
			ancientpower: ["9M"],
			attract: ["9M"],
			bind: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			headsmash: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			magnetrise: ["9M"],
			meteorbeam: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockpolish: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			screech: ["9M"],
			selfdestruct: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelroller: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thunderfang: ["9M"],
			wideguard: ["9M"],
		},
	},
	scizor: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			bulletpunch: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			defog: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			hardpress: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			lunge: ["9M"],
			nightslash: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychocut: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			steelbeam: ["9M"],
			steelwing: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			xscissor: ["9M"],
		},
	},
	heracross: {
		learnset: {
			aerialace: ["9M"],
			assurance: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			lowkick: ["9M"],
			lunge: ["9M"],
			megahorn: ["9M"],
			nightslash: ["9M"],
			pinmissile: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			seismictoss: ["9M"],
			shadowclaw: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			stoneedge: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
		},
	},
	skarmory: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			bodypress: ["9M"],
			bravebird: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			drillpeck: ["9M"],
			drillrun: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			metalsound: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			whirlwind: ["9M"],
			xscissor: ["9M"],
		},
	},
	houndoom: {
		learnset: {
			beatup: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			burningjealousy: ["9M"],
			comeuppance: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			doubleedge: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			inferno: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			willowisp: ["9M"],
		},
	},
	tyranitar: {
		learnset: {
			aerialace: ["9M"],
			ancientpower: ["9M"],
			assurance: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thrash: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
		},
	},
	pelipper: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			aquaring: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9M"],
			chillingwater: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			spitup: ["9M"],
			steelwing: ["9M"],
			stockpile: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swallow: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wideguard: ["9M"],
		},
	},
	gardevoir: {
		learnset: {
			alluringvoice: ["9M"],
			aurasphere: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			dazzlinggleam: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			guardswap: ["9M"],
			healpulse: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			meanlook: ["9M"],
			memento: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			tripleaxel: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			wish: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sableye: {
		learnset: {
			aerialace: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			drainpunch: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			feint: ["9M"],
			firepunch: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			gyroball: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			meanlook: ["9M"],
			megakick: ["9M"],
			metalburst: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poisonjab: ["9M"],
			poltergeist: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			quash: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			trick: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	aggron: {
		learnset: {
			ancientpower: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			metalburst: ["9M"],
			metalsound: ["9M"],
			meteorbeam: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelroller: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
			whirlpool: ["9M"],
		},
	},
	medicham: {
		learnset: {
			acupressure: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aurasphere: ["9M"],
			axekick: ["9M"],
			batonpass: ["9M"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulletpunch: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			detect: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			feint: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			guardswap: ["9M"],
			helpinghand: ["9M"],
			highjumpkick: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			imprison: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			poisonjab: ["9M"],
			powerswap: ["9M"],
			powertrick: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psychocut: ["9M"],
			psyshock: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	manectric: {
		learnset: {
			agility: ["9M"],
			attract: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			discharge: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			overheat: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			supercellslam: ["9M"],
			switcheroo: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	sharpedo: {
		learnset: {
			agility: ["9M"],
			ancientpower: ["9M"],
			aquajet: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bounce: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			poisonfang: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thrash: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	camerupt: {
		learnset: {
			amnesia: ["9M"],
			ancientpower: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			burningjealousy: ["9M"],
			charm: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			eruption: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			fissure: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			growth: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lashout: ["9M"],
			lavaplume: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spitup: ["9M"],
			stealthrock: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swallow: ["9M"],
			temperflare: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	torkoal: {
		learnset: {
			amnesia: ["9M"],
			ancientpower: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			burningjealousy: ["9M"],
			clearsmog: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			eruption: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			inferno: ["9M"],
			irondefense: ["9M"],
			lavaplume: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			rapidspin: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			shellsmash: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			temperflare: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	altaria: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			alluringvoice: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9M"],
			breakingswipe: ["9M"],
			bulldoze: ["9M"],
			cottonguard: ["9M"],
			dazzlinggleam: ["9M"],
			defog: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			moonblast: ["9M"],
			outrage: ["9M"],
			perishsong: ["9M"],
			playrough: ["9M"],
			pluck: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sing: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
		},
	},
	milotic: {
		learnset: {
			alluringvoice: ["9M"],
			aquaring: ["9M"],
			aquatail: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			coil: ["9M"],
			confuseray: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			dragoncheer: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			mirrorcoat: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scald: ["9M"],
			scaleshot: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tickle: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wrap: ["9M"],
		},
	},
	castform: {
		learnset: {
			amnesia: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			cosmicpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			futuresight: ["9M"],
			guardswap: ["9M"],
			hex: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			weatherball: ["9M"],
		},
	},
	banette: {
		learnset: {
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			magicroom: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	chimecho: {
		learnset: {
			allyswitch: ["9M"],
			batonpass: ["9M"],
			boomburst: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			cosmicpower: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			disable: ["9M"],
			doubleedge: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flashcannon: ["9M"],
			futuresight: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			healbell: ["9M"],
			healpulse: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			metalsound: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			recycle: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			screech: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thunderwave: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			uproar: ["9M"],
			wish: ["9M"],
			wrap: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	absol: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brutalswing: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			meanlook: ["9M"],
			megahorn: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			perishsong: ["9M"],
			phantomforce: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychocut: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	glalie: {
		learnset: {
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			disable: ["9M"],
			doubleteam: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			foulplay: ["9M"],
			freezedry: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spikes: ["9M"],
			spite: ["9M"],
			steelroller: ["9M"],
			substitute: ["9M"],
			switcheroo: ["9M"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
		},
	},
	torterra: {
		learnset: {
			amnesia: ["9M"],
			attract: ["9M"],
			bite: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			hardpress: ["9M"],
			headlongrush: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			seedbomb: ["9M"],
			shellsmash: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spitup: ["9M"],
			stealthrock: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swallow: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			thrash: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			wideguard: ["9M"],
			woodhammer: ["9M"],
			worryseed: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	infernape: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			attract: ["9M"],
			aurasphere: ["9M"],
			blastburn: ["9M"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			machpunch: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			ragingfury: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			switcheroo: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			torment: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			uproar: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	empoleon: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			aquajet: ["9M"],
			aquaring: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			drillpeck: ["9M"],
			dualwingbeat: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			liquidation: ["9M"],
			metalsound: ["9M"],
			mudslap: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			throatchop: ["9M"],
			tripleaxel: ["9M"],
			uproar: ["9M"],
			vacuumwave: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			wavecrash: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			yawn: ["9M"],
		},
	},
	luxray: {
		learnset: {
			agility: ["9M"],
			babydolleyes: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			discharge: ["9M"],
			doubleedge: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			nightslash: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			supercellslam: ["9M"],
			superpower: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	roserade: {
		learnset: {
			attract: ["9M"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			cottonspore: ["9M"],
			dazzlinggleam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			hyperbeam: ["9M"],
			ingrain: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lifedew: ["9M"],
			petalblizzard: ["9M"],
			petaldance: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeppowder: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stunspore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetscent: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			venoshock: ["9M"],
			weatherball: ["9M"],
			worryseed: ["9M"],
		},
	},
	rampardos: {
		learnset: {
			ancientpower: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			hammerarm: ["9M"],
			headsmash: ["9M"],
			heavyslam: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			meteorbeam: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			supercellslam: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
			whirlwind: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	bastiodon: {
		learnset: {
			ancientpower: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			fissure: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			guardsplit: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			metalburst: ["9M"],
			metalsound: ["9M"],
			meteorbeam: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			steelroller: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			wideguard: ["9M"],
		},
	},
	lopunny: {
		learnset: {
			acrobatics: ["9M"],
			afteryou: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			aurasphere: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			blizzard: ["9M"],
			bounce: ["9M"],
			brutalswing: ["9M"],
			charm: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			copycat: ["9M"],
			cosmicpower: ["9M"],
			cottonguard: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			dynamicpunch: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			firepunch: ["9M"],
			flail: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			highjumpkick: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			machpunch: ["9M"],
			megakick: ["9M"],
			mirrorcoat: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetkiss: ["9M"],
			switcheroo: ["9M"],
			swordsdance: ["9M"],
			teeterdance: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
		},
	},
	spiritomb: {
		learnset: {
			allyswitch: ["9M"],
			bodyslam: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			lashout: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			toxic: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			uproar: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
		},
	},
	garchomp: {
		learnset: {
			aerialace: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			poisonjab: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			thrash: ["9M"],
			thunderfang: ["9M"],
		},
	},
	lucario: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aurasphere: ["9M"],
			bite: ["9M"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			bonerush: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletpunch: ["9M"],
			calmmind: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			copycat: ["9M"],
			counter: ["9M"],
			crosschop: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			dragonpulse: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			extremespeed: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			finalgambit: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			highjumpkick: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			irontail: ["9M"],
			lifedew: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			metalsound: ["9M"],
			meteormash: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			terrainpulse: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			waterpulse: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	hippowdon: {
		learnset: {
			amnesia: ["9M"],
			bite: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			gigaimpact: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			ironhead: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scorchingsands: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spitup: ["9M"],
			stealthrock: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swallow: ["9M"],
			thunderfang: ["9M"],
			whirlwind: ["9M"],
			yawn: ["9M"],
		},
	},
	toxicroak: {
		learnset: {
			acidspray: ["9M"],
			aerialace: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			belch: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletpunch: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			corrosivegas: ["9M"],
			counter: ["9M"],
			crosschop: ["9M"],
			crosspoison: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			feint: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			toxic: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			venoshock: ["9M"],
			xscissor: ["9M"],
		},
	},
	abomasnow: {
		learnset: {
			auroraveil: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			chillingwater: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			frostbreath: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			growth: ["9M"],
			hardpress: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icehammer: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			ingrain: ["9M"],
			irontail: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
			woodhammer: ["9M"],
		},
	},
	weavile: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			avalanche: ["9M"],
			batonpass: ["9M"],
			beatup: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychocut: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			upperhand: ["9M"],
			waterpulse: ["9M"],
			xscissor: ["9M"],
		},
	},
	rhyperior: {
		learnset: {
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			guardsplit: ["9M"],
			hammerarm: ["9M"],
			heatcrash: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			horndrill: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			megakick: ["9M"],
			megahorn: ["9M"],
			metalburst: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockpolish: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			rockwrecker: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			supercellslam: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
		},
	},
	leafeon: {
		learnset: {
			aerialace: ["9M"],
			alluringvoice: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			bulletseed: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			knockoff: ["9M"],
			lastresort: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			weatherball: ["9M"],
			wish: ["9M"],
			xscissor: ["9M"],
			yawn: ["9M"],
		},
	},
	glaceon: {
		learnset: {
			alluringvoice: ["9M"],
			avalanche: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			freezedry: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			iceshard: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			lastresort: ["9M"],
			mirrorcoat: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	gliscor: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			crabhammer: ["9M"],
			crosspoison: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			firefang: ["9M"],
			fling: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lunge: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelwing: ["9M"],
			stoneedge: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			uturn: ["9M"],
			venoshock: ["9M"],
			xscissor: ["9M"],
		},
	},
	mamoswine: {
		learnset: {
			amnesia: ["9M"],
			ancientpower: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			freezedry: ["9M"],
			gigaimpact: ["9M"],
			hardpress: ["9M"],
			haze: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			iceshard: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			trailblaze: ["9M"],
		},
	},
	gallade: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9M"],
			alluringvoice: ["9M"],
			aquacutter: ["9M"],
			aurasphere: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			confuseray: ["9M"],
			dazzlinggleam: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			magicroom: ["9M"],
			meanlook: ["9M"],
			megakick: ["9M"],
			memento: ["9M"],
			mistyterrain: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			painsplit: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psychocut: ["9M"],
			psyshock: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sacredsword: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarblade: ["9M"],
			stoneedge: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			tripleaxel: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			wideguard: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	froslass: {
		learnset: {
			auroraveil: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			doubleteam: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			lightscreen: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spikes: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			switcheroo: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			tripleaxel: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
			willowisp: ["9M"],
		},
	},
	rotom: {
		learnset: {
			charge: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			darkpulse: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			foulplay: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trick: ["9M"],
			uproar: ["9M"],
			voltswitch: ["9M"],
			willowisp: ["9M"],
		},
	},
	rotomheat: {
		learnset: {
			overheat: ["9R"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["9R"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["9R"],
		},
	},
	rotomfan: {
		learnset: {
			airslash: ["9R"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["9R"],
		},
	},
	serperior: {
		learnset: {
			aerialace: ["9M"],
			attract: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulletseed: ["9M"],
			calmmind: ["9M"],
			coil: ["9M"],
			doubleedge: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			frenzyplant: ["9M"],
			gastroacid: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			meanlook: ["9M"],
			mirrorcoat: ["9M"],
			outrage: ["9M"],
			petalblizzard: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetscent: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			wrap: ["9M"],
		},
	},
	emboar: {
		learnset: {
			assurance: ["9M"],
			blastburn: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			burnup: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gyroball: ["9M"],
			hammerarm: ["9M"],
			hardpress: ["9M"],
			headsmash: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudslap: ["9M"],
			overheat: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scald: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thrash: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	samurott: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9M"],
			aquacutter: ["9M"],
			aquajet: ["9M"],
			aquatail: ["9M"],
			assurance: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			drillrun: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			megahorn: ["9M"],
			nightslash: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			sacredsword: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			xscissor: ["9M"],
		},
	},
	samurotthisui: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9M"],
			aquacutter: ["9M"],
			aquajet: ["9M"],
			aquatail: ["9M"],
			assurance: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			ceaselessedge: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			drillrun: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			liquidation: ["9M"],
			megahorn: ["9M"],
			nightslash: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			razorshell: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			sacredsword: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			smartstrike: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			whirlpool: ["9M"],
			xscissor: ["9M"],
		},
	},
	watchog: {
		learnset: {
			afteryou: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bulletseed: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icepunch: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			meanlook: ["9M"],
			mudshot: ["9M"],
			nastyplot: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			swordsdance: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	liepard: {
		learnset: {
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			burningjealousy: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			firefang: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			psychocut: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			uturn: ["9M"],
			yawn: ["9M"],
		},
	},
	simisage: {
		learnset: {
			acrobatics: ["9M"],
			attract: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			stuffcheeks: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			torment: ["9M"],
			trailblaze: ["9M"],
			uproar: ["9M"],
		},
	},
	simisear: {
		learnset: {
			acrobatics: ["9M"],
			amnesia: ["9M"],
			attract: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			blazekick: ["9M"],
			brickbreak: ["9M"],
			burningjealousy: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stuffcheeks: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			uproar: ["9M"],
			willowisp: ["9M"],
			yawn: ["9M"],
		},
	},
	simipour: {
		learnset: {
			acrobatics: ["9M"],
			aquaring: ["9M"],
			attract: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			brickbreak: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scald: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stuffcheeks: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			uproar: ["9M"],
			waterfall: ["9M"],
		},
	},
	excadrill: {
		learnset: {
			aerialace: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crushclaw: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			horndrill: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			megahorn: ["9M"],
			metalsound: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rapidspin: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			smartstrike: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			throatchop: ["9M"],
			xscissor: ["9M"],
		},
	},
	audino: {
		learnset: {
			afteryou: ["9M"],
			allyswitch: ["9M"],
			amnesia: ["9M"],
			attract: ["9M"],
			babydolleyes: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			healpulse: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mistyterrain: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			simplebeam: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			sweetkiss: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trickroom: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	conkeldurr: {
		learnset: {
			attract: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			defog: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			hammerarm: ["9M"],
			hardpress: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			knockoff: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			machpunch: ["9M"],
			megakick: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			upperhand: ["9M"],
			wideguard: ["9M"],
		},
	},
	whimsicott: {
		learnset: {
			attract: ["9M"],
			beatup: ["9M"],
			charm: ["9M"],
			cottonguard: ["9M"],
			cottonspore: ["9M"],
			dazzlinggleam: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			memento: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			playrough: ["9M"],
			poisonpowder: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stunspore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			switcheroo: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			tickle: ["9M"],
			trickroom: ["9M"],
			uturn: ["9M"],
			worryseed: ["9M"],
		},
	},
	krookodile: {
		learnset: {
			aerialace: ["9M"],
			aquatail: ["9M"],
			assurance: ["9M"],
			beatup: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			fissure: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			smackdown: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			torment: ["9M"],
			uproar: ["9M"],
		},
	},
	cofagrigus: {
		learnset: {
			allyswitch: ["9M"],
			attract: ["9M"],
			bodypress: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			guardsplit: ["9M"],
			guardswap: ["9M"],
			haze: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			meanlook: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			powersplit: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			thief: ["9M"],
			toxicspikes: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	garbodor: {
		learnset: {
			acidspray: ["9M"],
			amnesia: ["9M"],
			ancientpower: ["9M"],
			attract: ["9M"],
			belch: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			clearsmog: ["9M"],
			corrosivegas: ["9M"],
			crosspoison: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			drainpunch: ["9M"],
			endure: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			hyperbeam: ["9M"],
			mudshot: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			round: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			stockpile: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swallow: ["9M"],
			thief: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			venoshock: ["9M"],
		},
	},
	zoroark: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightdaze: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			trick: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
		},
	},
	zoroarkhisui: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			bittermalice: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			comeuppance: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			torment: ["9M"],
			trick: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			willowisp: ["9M"],
		},
	},
	reuniclus: {
		learnset: {
			acidarmor: ["9M"],
			allyswitch: ["9M"],
			attract: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			drainpunch: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			guardswap: ["9M"],
			gyroball: ["9M"],
			hammerarm: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			steelroller: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	vanilluxe: {
		learnset: {
			acidarmor: ["9M"],
			allyswitch: ["9M"],
			attract: ["9M"],
			auroraveil: ["9M"],
			avalanche: ["9M"],
			beatup: ["9M"],
			blizzard: ["9M"],
			chillingwater: ["9M"],
			endure: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			magnetrise: ["9M"],
			mirrorcoat: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			selfdestruct: ["9M"],
			sheercold: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			uproar: ["9M"],
			weatherball: ["9M"],
		},
	},
	emolga: {
		learnset: {
			acrobatics: ["9M"],
			agility: ["9M"],
			airslash: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			covet: ["9M"],
			defog: ["9M"],
			discharge: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			eerieimpulse: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			helpinghand: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			nuzzle: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			speedswap: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	chandelure: {
		learnset: {
			acidarmor: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			clearsmog: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			heatwave: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			inferno: ["9M"],
			lashout: ["9M"],
			memento: ["9M"],
			minimize: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			overheat: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			poltergeist: ["9M"],
			powersplit: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
		},
	},
	beartic: {
		learnset: {
			aerialace: ["9M"],
			aquajet: ["9M"],
			assurance: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icepunch: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nightslash: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowclaw: ["9M"],
			sheercold: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			xscissor: ["9M"],
			yawn: ["9M"],
		},
	},
	stunfisk: {
		learnset: {
			attract: ["9M"],
			bounce: ["9M"],
			bulldoze: ["9M"],
			charge: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			foulplay: ["9M"],
			lashout: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflecttype: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scald: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			surf: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			uproar: ["9M"],
			yawn: ["9M"],
		},
	},
	stunfiskgalar: {
		learnset: {
			attract: ["9M"],
			bind: ["9M"],
			bounce: ["9M"],
			bulldoze: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			foulplay: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			lashout: ["9M"],
			metalsound: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflecttype: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scald: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snaptrap: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			surf: ["9M"],
			terrainpulse: ["9M"],
			thunderwave: ["9M"],
			uproar: ["9M"],
			yawn: ["9M"],
		},
	},
	golurk: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			chargebeam: ["9M"],
			closecombat: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			gyroball: ["9M"],
			hammerarm: ["9M"],
			hardpress: ["9M"],
			headlongrush: ["9M"],
			heatcrash: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mudslap: ["9M"],
			nightshade: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scorchingsands: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowpunch: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			trick: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	hydreigon: {
		learnset: {
			acrobatics: ["9M"],
			assurance: ["9M"],
			beatup: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			doublehit: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			dualwingbeat: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			steelwing: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			triattack: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	volcarona: {
		learnset: {
			acrobatics: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			amnesia: ["9M"],
			bodyslam: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			calmmind: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fierydance: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fly: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			leechlife: ["9M"],
			lightscreen: ["9M"],
			lunge: ["9M"],
			morningsun: ["9M"],
			mysticalfire: ["9M"],
			overheat: ["9M"],
			poisonjab: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			quiverdance: ["9M"],
			ragepowder: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			screech: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stringshot: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tailwind: ["9M"],
			thrash: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			whirlwind: ["9M"],
			wildcharge: ["9M"],
			willowisp: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	chesnaught: {
		learnset: {
			aerialace: ["9M"],
			bellydrum: ["9M"],
			bite: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dragonclaw: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			gyroball: ["9M"],
			hammerarm: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			spikyshield: ["9M"],
			steelroller: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			taunt: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			wideguard: ["9M"],
			woodhammer: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	delphox: {
		learnset: {
			agility: ["9M"],
			blastburn: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			copycat: ["9M"],
			dazzlinggleam: ["9M"],
			doubleteam: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			howl: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			imprison: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			magicroom: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			mysticalfire: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			switcheroo: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			wish: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	greninja: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			blizzard: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dive: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			nightslash: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			shadowsneak: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgewave: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			switcheroo: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			waterpulse: ["9M"],
			watershuriken: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
		},
	},
	diggersby: {
		learnset: {
			agility: ["9M"],
			attract: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			hammerarm: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scorchingsands: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superfang: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
		},
	},
	talonflame: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			blazekick: ["9M"],
			bravebird: ["9M"],
			bulkup: ["9M"],
			defog: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flail: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			whirlwind: ["9M"],
			willowisp: ["9M"],
		},
	},
	vivillon: {
		learnset: {
			acrobatics: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			poisonpowder: ["9M"],
			pollenpuff: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			quiverdance: ["9M"],
			ragepowder: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			skittersmack: ["9M"],
			sleeppowder: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stringshot: ["9M"],
			strugglebug: ["9M"],
			stunspore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			weatherball: ["9M"],
			whirlwind: ["9M"],
		},
	},
	vivillonfancy: {},
	vivillonpokeball: {},
	floetteeternal: {
		learnset: {
			alluringvoice: ["9M"],
			batonpass: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			grassknot: ["9M"],
			grassyterrain: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			lightofruin: ["9M"],
			lightscreen: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			petalblizzard: ["9M"],
			petaldance: ["9M"],
			pollenpuff: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			synthesis: ["9M"],
			tearfullook: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			wish: ["9M"],
		},
	},
	florges: {
		learnset: {
			alluringvoice: ["9M"],
			batonpass: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			petalblizzard: ["9M"],
			petaldance: ["9M"],
			pollenpuff: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			seedbomb: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			synthesis: ["9M"],
			tearfullook: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			wish: ["9M"],
		},
	},
	pangoro: {
		learnset: {
			attract: ["9M"],
			beatup: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			bulletpunch: ["9M"],
			circlethrow: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			comeuppance: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			darkestlariat: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			dragonclaw: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			hammerarm: ["9M"],
			headlongrush: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icepunch: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M"],
			partingshot: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			quash: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seismictoss: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			stormthrow: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			uproar: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	furfrou: {
		learnset: {
			attract: ["9M"],
			babydolleyes: ["9M"],
			bite: ["9M"],
			charm: ["9M"],
			cottonguard: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			thunderfang: ["9M"],
			thunderwave: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meowstic: {
		learnset: {
			alluringvoice: ["9M"],
			batonpass: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			covet: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			meanlook: ["9M"],
			mistyterrain: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psychup: ["9M"],
			psyshock: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			tailslap: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wish: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	meowsticf: {
		learnset: {
			alluringvoice: ["9M"],
			batonpass: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			covet: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psychup: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			tailslap: ["9M"],
			thunderbolt: ["9M"],
			thunderwave: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	aegislash: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9M"],
			attract: ["9M"],
			block: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			closecombat: ["9M"],
			destinybond: ["9M"],
			doublehit: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			headsmash: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			kingsshield: ["9M"],
			metalsound: ["9M"],
			nightslash: ["9M"],
			poltergeist: ["9M"],
			powertrick: ["9M"],
			protect: ["9M"],
			psychocut: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			sacredsword: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarblade: ["9M"],
			steelbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			wideguard: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	aromatisse: {
		learnset: {
			afteryou: ["9M"],
			alluringvoice: ["9M"],
			allyswitch: ["9M"],
			aromaticmist: ["9M"],
			attract: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			dazzlinggleam: ["9M"],
			disable: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			lightscreen: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			nastyplot: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			sweetkiss: ["9M"],
			sweetscent: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			trickroom: ["9M"],
			wish: ["9M"],
		},
	},
	slurpuff: {
		learnset: {
			afteryou: ["9M"],
			amnesia: ["9M"],
			attract: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			cottonguard: ["9M"],
			cottonspore: ["9M"],
			dazzlinggleam: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flamethrower: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			mistyexplosion: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stickyweb: ["9M"],
			stringshot: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			sweetscent: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	clawitzer: {
		learnset: {
			aquajet: ["9M"],
			aquatail: ["9M"],
			aurasphere: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			chillingwater: ["9M"],
			crabhammer: ["9M"],
			darkpulse: ["9M"],
			dive: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			flashcannon: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			healpulse: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			terrainpulse: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			venoshock: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
		},
	},
	heliolisk: {
		learnset: {
			agility: ["9M"],
			allyswitch: ["9M"],
			attract: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electrify: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9M"],
			grassknot: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			morningsun: ["9M"],
			mudslap: ["9M"],
			paraboliccharge: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			shedtail: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M"],
			weatherball: ["9M"],
			wildcharge: ["9M"],
		},
	},
	tyrantrum: {
		learnset: {
			ancientpower: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			highhorsepower: ["9M"],
			horndrill: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icefang: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lashout: ["9M"],
			meteorbeam: ["9M"],
			outrage: ["9M"],
			playrough: ["9M"],
			poisonfang: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockpolish: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			thrash: ["9M"],
			thunderfang: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	aurorus: {
		learnset: {
			ancientpower: ["9M"],
			attract: ["9M"],
			auroraveil: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chillingwater: ["9M"],
			darkpulse: ["9M"],
			discharge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			freezedry: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			meteorbeam: ["9M"],
			mirrorcoat: ["9M"],
			mudshot: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandstorm: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			weatherball: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sylveon: {
		learnset: {
			alluringvoice: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			copycat: ["9M"],
			covet: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			flail: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			mudslap: ["9M"],
			mysticalfire: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			tickle: ["9M"],
			trailblaze: ["9M"],
			weatherball: ["9M"],
			wish: ["9M"],
			yawn: ["9M"],
		},
	},
	hawlucha: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bounce: ["9M"],
			bravebird: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			crosschop: ["9M"],
			defog: ["9M"],
			detect: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dualwingbeat: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			feint: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			flyingpress: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			highjumpkick: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			lunge: ["9M"],
			meanlook: ["9M"],
			megakick: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			steelwing: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			uproar: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	dedenne: {
		learnset: {
			agility: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			charm: ["9M"],
			covet: ["9M"],
			dazzlinggleam: ["9M"],
			dig: ["9M"],
			discharge: ["9M"],
			drainingkiss: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irontail: ["9M"],
			lightscreen: ["9M"],
			magnetrise: ["9M"],
			mistyterrain: ["9M"],
			nuzzle: ["9M"],
			paraboliccharge: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			tearfullook: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	goodra: {
		learnset: {
			acidarmor: ["9M"],
			acidspray: ["9M"],
			aquatail: ["9M"],
			assurance: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flail: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lifedew: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			scald: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			tearfullook: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
		},
	},
	goodrahisui: {
		learnset: {
			acidspray: ["9M"],
			ancientpower: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fireblast: ["9M"],
			firepunch: ["9M"],
			flail: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			heavyslam: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lifedew: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			shelter: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			steelbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			tearfullook: ["9M"],
			thunder: ["9M"],
			thunderpunch: ["9M"],
			thunderbolt: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
		},
	},
	klefki: {
		learnset: {
			calmmind: ["9M"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fairylock: ["9M"],
			flashcannon: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			magnetrise: ["9M"],
			metalsound: ["9M"],
			mistyterrain: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			recycle: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandstorm: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spikes: ["9M"],
			steelbeam: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			switcheroo: ["9M"],
			thief: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			trickroom: ["9M"],
		},
	},
	trevenant: {
		learnset: {
			allyswitch: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			burningjealousy: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			focusblast: ["9M"],
			forestscurse: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			haze: ["9M"],
			hex: ["9M"],
			hornleech: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			ingrain: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			phantomforce: ["9M"],
			poisonjab: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			toxic: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			woodhammer: ["9M"],
			xscissor: ["9M"],
		},
	},
	gourgeist: {
		learnset: {
			allyswitch: ["9M"],
			attract: ["9M"],
			brutalswing: ["9M"],
			bulletseed: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			gyroball: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			imprison: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			moonblast: ["9M"],
			mysticalfire: ["9M"],
			nastyplot: ["9M"],
			painsplit: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowsneak: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			trickortreat: ["9M"],
			willowisp: ["9M"],
			worryseed: ["9M"],
		},
	},
	gourgeistsuper: {},
	avalugg: {
		learnset: {
			auroraveil: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			frostbreath: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icespinner: ["9M"],
			iciclecrash: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			mirrorcoat: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			wideguard: ["9M"],
		},
	},
	avalugghisui: {
		learnset: {
			ancientpower: ["9M"],
			auroraveil: ["9M"],
			avalanche: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icespinner: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			mirrorcoat: ["9M"],
			mountaingale: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snowscape: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			wideguard: ["9M"],
		},
	},
	noivern: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			boomburst: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			darkpulse: ["9M"],
			defog: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			leechlife: ["9M"],
			moonlight: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			switcheroo: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			whirlwind: ["9M"],
			wildcharge: ["9M"],
			xscissor: ["9M"],
		},
	},
	decidueye: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			batonpass: ["9M"],
			bravebird: ["9M"],
			bulletseed: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			defog: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			phantomforce: ["9M"],
			pluck: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychocut: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			spiritshackle: ["9M"],
			spite: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			tailwind: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
		},
	},
	decidueyehisui: {
		learnset: {
			aerialace: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			aurasphere: ["9M"],
			batonpass: ["9M"],
			bravebird: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulletseed: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			confuseray: ["9M"],
			defog: ["9M"],
			doubleteam: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			leafblade: ["9M"],
			leafstorm: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			pluck: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rocktomb: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			synthesis: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			trailblaze: ["9M"],
			triplearrows: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
		},
	},
	incineroar: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			assurance: ["9M"],
			attract: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			blastburn: ["9M"],
			blazekick: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			burningjealousy: ["9M"],
			closecombat: ["9M"],
			crosschop: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			darkestlariat: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			lashout: ["9M"],
			leechlife: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			partingshot: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swagger: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
		},
	},
	primarina: {
		learnset: {
			acrobatics: ["9M"],
			alluringvoice: ["9M"],
			amnesia: ["9M"],
			aquajet: ["9M"],
			aquaring: ["9M"],
			attract: ["9M"],
			babydolleyes: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			dazzlinggleam: ["9M"],
			dive: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			irontail: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			moonblast: ["9M"],
			perishsong: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sing: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			sparklingaria: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			tripleaxel: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			weatherball: ["9M"],
			whirlpool: ["9M"],
			wonderroom: ["9M"],
		},
	},
	toucannon: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			attract: ["9M"],
			beakblast: ["9M"],
			boomburst: ["9M"],
			bravebird: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			drillpeck: ["9M"],
			dualwingbeat: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			flamecharge: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			knockoff: ["9M"],
			overheat: ["9M"],
			pluck: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			seedbomb: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
		},
	},
	crabominable: {
		learnset: {
			amnesia: ["9M"],
			avalanche: ["9M"],
			blizzard: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			crabhammer: ["9M"],
			dig: ["9M"],
			drainpunch: ["9M"],
			dynamicpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hardpress: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icehammer: ["9M"],
			icepunch: ["9M"],
			icespinner: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			knockoff: ["9M"],
			liquidation: ["9M"],
			machpunch: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swagger: ["9M"],
			thief: ["9M"],
			thunderpunch: ["9M"],
			upperhand: ["9M"],
			wideguard: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	lycanroc: {
		learnset: {
			accelerock: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			mudslap: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailslap: ["9M"],
			taunt: ["9M"],
			thrash: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	lycanrocmidnight: {
		learnset: {
			bite: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focuspunch: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			lastresort: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			trailblaze: ["9M"],
			upperhand: ["9M"],
			uproar: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	lycanrocdusk: {
		learnset: {
			accelerock: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			charm: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			crunch: ["9M"],
			crushclaw: ["9M"],
			dig: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			howl: ["9M"],
			hypervoice: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lastresort: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			swordsdance: ["9M"],
			tailslap: ["9M"],
			taunt: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	toxapex: {
		learnset: {
			acidspray: ["9M"],
			banefulbunker: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			chillingwater: ["9M"],
			crosspoison: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M"],
			hex: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			infestation: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			liquidation: ["9M"],
			lunge: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			pinmissile: ["9M"],
			poisonjab: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			spitup: ["9M"],
			stockpile: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swallow: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			venoshock: ["9M"],
			waterpulse: ["9M"],
			wideguard: ["9M"],
		},
	},
	mudsdale: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fissure: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
		},
	},
	araquanid: {
		learnset: {
			aquaring: ["9M"],
			attract: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			chillingwater: ["9M"],
			crunch: ["9M"],
			dive: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			infestation: ["9M"],
			irondefense: ["9M"],
			leechlife: ["9M"],
			liquidation: ["9M"],
			lunge: ["9M"],
			magicroom: ["9M"],
			mirrorcoat: ["9M"],
			poisonjab: ["9M"],
			pounce: ["9M"],
			powersplit: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			soak: ["9M"],
			spitup: ["9M"],
			stickyweb: ["9M"],
			stockpile: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			trailblaze: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			wideguard: ["9M"],
			wonderroom: ["9M"],
			xscissor: ["9M"],
		},
	},
	salazzle: {
		learnset: {
			acidspray: ["9M"],
			acrobatics: ["9M"],
			agility: ["9M"],
			beatup: ["9M"],
			belch: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			burningjealousy: ["9M"],
			corrosivegas: ["9M"],
			crosspoison: ["9M"],
			disable: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firelash: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			leechlife: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			overheat: ["9M"],
			payback: ["9M"],
			poisonfang: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			shadowclaw: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			sweetscent: ["9M"],
			taunt: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			willowisp: ["9M"],
		},
	},
	tsareena: {
		learnset: {
			acrobatics: ["9M"],
			acupressure: ["9M"],
			aromaticmist: ["9M"],
			bounce: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			fling: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			helpinghand: ["9M"],
			highjumpkick: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			leafstorm: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			payback: ["9M"],
			petalblizzard: ["9M"],
			playrough: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			rapidspin: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			solarblade: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			sweetscent: ["9M"],
			synthesis: ["9M"],
			taunt: ["9M"],
			teeterdance: ["9M"],
			trailblaze: ["9M"],
			tripleaxel: ["9M"],
			tropkick: ["9M"],
			uturn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	oranguru: {
		learnset: {
			afteryou: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			imprison: ["9M"],
			instruct: ["9M"],
			knockoff: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			megakick: ["9M"],
			nastyplot: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			quash: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			terrainpulse: ["9M"],
			thunder: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wonderroom: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	passimian: {
		learnset: {
			acrobatics: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			beatup: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			curse: ["9M"],
			doubleedge: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			gyroball: ["9M"],
			hyperbeam: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			knockoff: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			seismictoss: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snore: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			uproar: ["9M"],
			vacuumwave: ["9M"],
		},
	},
	mimikyu: {
		learnset: {
			babydolleyes: ["9M"],
			beatup: ["9M"],
			bulkup: ["9M"],
			burningjealousy: ["9M"],
			charm: ["9M"],
			confuseray: ["9M"],
			copycat: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			destinybond: ["9M"],
			doubleteam: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			leechlife: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			mistyterrain: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			playrough: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			woodhammer: ["9M"],
			xscissor: ["9M"],
		},
	},
	drampa: {
		learnset: {
			amnesia: ["9M"],
			attract: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fling: ["9M"],
			fly: ["9M"],
			focusblast: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9M"],
			grassknot: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icywind: ["9M"],
			lashout: ["9M"],
			lightscreen: ["9M"],
			outrage: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			scaleshot: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			surf: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			triattack: ["9M"],
			uproar: ["9M"],
			whirlwind: ["9M"],
		},
	},
	kommoo: {
		learnset: {
			aerialace: ["9M"],
			attract: ["9M"],
			aurasphere: ["9M"],
			bellydrum: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			boomburst: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulkup: ["9M"],
			bulldoze: ["9M"],
			clangingscales: ["9M"],
			clangoroussoul: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			drainpunch: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			flamethrower: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			lowkick: ["9M"],
			megakick: ["9M"],
			metalsound: ["9M"],
			nobleroar: ["9M"],
			outrage: ["9M"],
			payback: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			upperhand: ["9M"],
			uproar: ["9M"],
			vacuumwave: ["9M"],
			xscissor: ["9M"],
		},
	},
	corviknight: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9M"],
			bulkup: ["9M"],
			curse: ["9M"],
			defog: ["9M"],
			doubleedge: ["9M"],
			drillpeck: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			featherdance: ["9M"],
			flashcannon: ["9M"],
			fly: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			metalsound: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			pluck: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roost: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			screech: ["9M"],
			skyattack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			steelbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			tailwind: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			uturn: ["9M"],
		},
	},
	flapple: {
		learnset: {
			acidspray: ["9M"],
			acrobatics: ["9M"],
			aerialace: ["9M"],
			airslash: ["9M"],
			bulletseed: ["9M"],
			dracometeor: ["9M"],
			dragondance: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dualwingbeat: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fly: ["9M"],
			focusenergy: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			gravapple: ["9M"],
			growth: ["9M"],
			heavyslam: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			outrage: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			recycle: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
		},
	},
	appletun: {
		learnset: {
			amnesia: ["9M"],
			appleacid: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			dracometeor: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			gyroball: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lightscreen: ["9M"],
			outrage: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			recycle: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			superpower: ["9M"],
			sweetscent: ["9M"],
			trailblaze: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sandaconda: {
		learnset: {
			belch: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			coil: ["9M"],
			dig: ["9M"],
			dragonrush: ["9M"],
			drillrun: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			firefang: ["9M"],
			gigaimpact: ["9M"],
			glare: ["9M"],
			highhorsepower: ["9M"],
			hurricane: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lastresort: ["9M"],
			minimize: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			screech: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			thunderfang: ["9M"],
			wrap: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	polteageist: {
		learnset: {
			allyswitch: ["9M"],
			aromaticmist: ["9M"],
			batonpass: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			lightscreen: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shellsmash: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			strengthsap: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sweetscent: ["9M"],
			teatime: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
		},
	},
	polteageistantique: {},
	hatterene: {
		learnset: {
			afteryou: ["9M"],
			agility: ["9M"],
			aromaticmist: ["9M"],
			batonpass: ["9M"],
			brutalswing: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			darkpulse: ["9M"],
			dazzlinggleam: ["9M"],
			drainingkiss: ["9M"],
			endure: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			futuresight: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			guardswap: ["9M"],
			healpulse: ["9M"],
			healingwish: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			lifedew: ["9M"],
			lightscreen: ["9M"],
			magicpowder: ["9M"],
			magicroom: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			mysticalfire: ["9M"],
			nuzzle: ["9M"],
			painsplit: ["9M"],
			playrough: ["9M"],
			powerswap: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psychocut: ["9M"],
			psyshock: ["9M"],
			quash: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			thunderwave: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			wonderroom: ["9M"],
		},
	},
	mrrime: {
		learnset: {
			afteryou: ["9M"],
			allyswitch: ["9M"],
			attract: ["9M"],
			avalanche: ["9M"],
			batonpass: ["9M"],
			blizzard: ["9M"],
			block: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			copycat: ["9M"],
			dazzlinggleam: ["9M"],
			drainpunch: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			freezedry: ["9M"],
			frostbreath: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			guardswap: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			iceshard: ["9M"],
			icespinner: ["9M"],
			iciclespear: ["9M"],
			icywind: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			megakick: ["9M"],
			mirrorcoat: ["9M"],
			mistyterrain: ["9M"],
			nastyplot: ["9M"],
			payback: ["9M"],
			powersplit: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			recycle: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roleplay: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			sheercold: ["9M"],
			skillswap: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			snowscape: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			teeterdance: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			torment: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			tripleaxel: ["9M"],
			uproar: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	runerigus: {
		learnset: {
			allyswitch: ["9M"],
			amnesia: ["9M"],
			attract: ["9M"],
			bodypress: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			dragonpulse: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			guardsplit: ["9M"],
			guardswap: ["9M"],
			haze: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			meanlook: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			payback: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			powersplit: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			selfdestruct: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowpunch: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			toxicspikes: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			willowisp: ["9M"],
			wonderroom: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	alcremie: {
		learnset: {
			acidarmor: ["9M"],
			alluringvoice: ["9M"],
			aromaticmist: ["9M"],
			attract: ["9M"],
			babydolleyes: ["9M"],
			calmmind: ["9M"],
			charm: ["9M"],
			dazzlinggleam: ["9M"],
			decorate: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			entrainment: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			magicroom: ["9M"],
			mistyexplosion: ["9M"],
			mistyterrain: ["9M"],
			mysticalfire: ["9M"],
			painsplit: ["9M"],
			playrough: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psyshock: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			safeguard: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sweetkiss: ["9M"],
			sweetscent: ["9M"],
			triattack: ["9M"],
			wonderroom: ["9M"],
		},
	},
	morpeko: {
		learnset: {
			agility: ["9M"],
			assurance: ["9M"],
			aurawheel: ["9M"],
			batonpass: ["9M"],
			bite: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			crunch: ["9M"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			firefang: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			foulplay: ["9M"],
			icefang: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			partingshot: ["9M"],
			payback: ["9M"],
			powertrip: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quash: ["9M"],
			quickattack: ["9M"],
			rapidspin: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			risingvoltage: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			snore: ["9M"],
			spite: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			superfang: ["9M"],
			swagger: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			thunder: ["9M"],
			thunderfang: ["9M"],
			thunderpunch: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			tickle: ["9M"],
			torment: ["9M"],
			uproar: ["9M"],
			voltswitch: ["9M"],
			wildcharge: ["9M"],
		},
	},
	dragapult: {
		learnset: {
			acrobatics: ["9M"],
			agility: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			beatup: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			disable: ["9M"],
			dive: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragondance: ["9M"],
			dragondarts: ["9M"],
			dragonpulse: ["9M"],
			dragonrush: ["9M"],
			dragontail: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			flamethrower: ["9M"],
			fly: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			infestation: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			lockon: ["9M"],
			nightshade: ["9M"],
			outrage: ["9M"],
			phantomforce: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			quickattack: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			round: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snore: ["9M"],
			solarbeam: ["9M"],
			steelwing: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			surf: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			triattack: ["9M"],
			uturn: ["9M"],
			willowisp: ["9M"],
		},
	},
	wyrdeer: {
		learnset: {
			agility: ["9M"],
			bite: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			disable: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			extrasensory: ["9M"],
			facade: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			hypnosis: ["9M"],
			imprison: ["9M"],
			lightscreen: ["9M"],
			lunge: ["9M"],
			megahorn: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicnoise: ["9M"],
			psyshieldbash: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			roleplay: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			thrash: ["9M"],
			throatchop: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			uproar: ["9M"],
			wildcharge: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	kleavor: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			ancientpower: ["9M"],
			batonpass: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bugbite: ["9M"],
			bugbuzz: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			defog: ["9M"],
			doublehit: ["9M"],
			doubleteam: ["9M"],
			doubleedge: ["9M"],
			dualwingbeat: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			feint: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			lightscreen: ["9M"],
			lunge: ["9M"],
			nightslash: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			stealthrock: ["9M"],
			stoneaxe: ["9M"],
			stoneedge: ["9M"],
			strugglebug: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			tailwind: ["9M"],
			thief: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			vacuumwave: ["9M"],
			xscissor: ["9M"],
		},
	},
	basculegion: {
		learnset: {
			agility: ["9M"],
			aquajet: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			doubleedge: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			hex: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			lastrespects: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nightshade: ["9M"],
			outrage: ["9M"],
			painsplit: ["9M"],
			phantomforce: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			thrash: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			wavecrash: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	basculegionf: {
		learnset: {
			agility: ["9M"],
			aquajet: ["9M"],
			bite: ["9M"],
			blizzard: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			doubleedge: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flail: ["9M"],
			flipturn: ["9M"],
			gigaimpact: ["9M"],
			headsmash: ["9M"],
			hex: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icebeam: ["9M"],
			icefang: ["9M"],
			icywind: ["9M"],
			lastrespects: ["9M"],
			liquidation: ["9M"],
			mudshot: ["9M"],
			muddywater: ["9M"],
			nightshade: ["9M"],
			outrage: ["9M"],
			painsplit: ["9M"],
			phantomforce: ["9M"],
			protect: ["9M"],
			psychicfangs: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			scaleshot: ["9M"],
			scaryface: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			snowscape: ["9M"],
			soak: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			thrash: ["9M"],
			uproar: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			wavecrash: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sneasler: {
		learnset: {
			acidspray: ["9M"],
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			calmmind: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			dig: ["9M"],
			direclaw: ["9M"],
			doublehit: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			feint: ["9M"],
			firepunch: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickattack: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			screech: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			spite: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			switcheroo: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			vacuumwave: ["9M"],
			venoshock: ["9M"],
			xscissor: ["9M"],
		},
	},
	meowscarada: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			allyswitch: ["9M"],
			aurasphere: ["9M"],
			bite: ["9M"],
			brickbreak: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			darkpulse: ["9M"],
			doubleteam: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			fling: ["9M"],
			flowertrick: ["9M"],
			foulplay: ["9M"],
			frenzyplant: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			knockoff: ["9M"],
			lashout: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudslap: ["9M"],
			nastyplot: ["9M"],
			nightslash: ["9M"],
			petalblizzard: ["9M"],
			playrough: ["9M"],
			pollenpuff: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			quickattack: ["9M"],
			rest: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderpunch: ["9M"],
			toxicspikes: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M"],
			worryseed: ["9M"],
		},
	},
	skeledirge: {
		learnset: {
			alluringvoice: ["9M"],
			belch: ["9M"],
			bite: ["9M"],
			blastburn: ["9M"],
			bodyslam: ["9M"],
			burnup: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigaimpact: ["9M"],
			heatcrash: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			imprison: ["9M"],
			mudslap: ["9M"],
			nightshade: ["9M"],
			outrage: ["9M"],
			overheat: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			round: ["9M"],
			scaryface: ["9M"],
			scorchingsands: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			sing: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			solarbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			temperflare: ["9M"],
			thunderfang: ["9M"],
			torchsong: ["9M"],
			willowisp: ["9M"],
			yawn: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	quaquaval: {
		learnset: {
			acrobatics: ["9M"],
			aerialace: ["9M"],
			agility: ["9M"],
			aircutter: ["9M"],
			airslash: ["9M"],
			aquacutter: ["9M"],
			aquajet: ["9M"],
			aquastep: ["9M"],
			batonpass: ["9M"],
			bravebird: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			coaching: ["9M"],
			counter: ["9M"],
			detect: ["9M"],
			doublehit: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusenergy: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hurricane: ["9M"],
			hydrocannon: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			icespinner: ["9M"],
			icywind: ["9M"],
			knockoff: ["9M"],
			lastresort: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			megakick: ["9M"],
			mistyterrain: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			rapidspin: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			roost: ["9M"],
			sleeptalk: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			tripleaxel: ["9M"],
			uturn: ["9M"],
			upperhand: ["9M"],
			waterpulse: ["9M"],
			wavecrash: ["9M"],
			whirlpool: ["9M"],
		},
	},
	maushold: {
		learnset: {
			aerialace: ["9M"],
			afteryou: ["9M"],
			agility: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			beatup: ["9M"],
			bite: ["9M"],
			bulletseed: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			copycat: ["9M"],
			crunch: ["9M"],
			dig: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			encore: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			followme: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			playrough: ["9M"],
			populationbomb: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			seedbomb: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			switcheroo: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			thunderwave: ["9M"],
			tickle: ["9M"],
			tidyup: ["9M"],
			trailblaze: ["9M"],
			uturn: ["9M"],
			waterpulse: ["9M"],
		},
	},
	garganacl: {
		learnset: {
			ancientpower: ["9M"],
			avalanche: ["9M"],
			block: ["9M"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			brickbreak: ["9M"],
			bulldoze: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			dynamicpunch: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			firepunch: ["9M"],
			fissure: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			gravity: ["9M"],
			hammerarm: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			icepunch: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			meteorbeam: ["9M"],
			mudshot: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockpolish: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			saltcure: ["9M"],
			sandstorm: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			stealthrock: ["9M"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thunderpunch: ["9M"],
			wideguard: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	armarouge: {
		learnset: {
			acidspray: ["9M"],
			allyswitch: ["9M"],
			armorcannon: ["9M"],
			aurasphere: ["9M"],
			burnup: ["9M"],
			calmmind: ["9M"],
			clearsmog: ["9M"],
			confuseray: ["9M"],
			darkpulse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			dragonpulse: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lavaplume: ["9M"],
			lightscreen: ["9M"],
			meteorbeam: ["9M"],
			mysticalfire: ["9M"],
			nightshade: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			scorchingsands: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			taunt: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			weatherball: ["9M"],
			wideguard: ["9M"],
			willowisp: ["9M"],
		},
	},
	ceruledge: {
		learnset: {
			allyswitch: ["9M"],
			bitterblade: ["9M"],
			brickbreak: ["9M"],
			bulkup: ["9M"],
			burnup: ["9M"],
			clearsmog: ["9M"],
			closecombat: ["9M"],
			confuseray: ["9M"],
			curse: ["9M"],
			destinybond: ["9M"],
			disable: ["9M"],
			dragonclaw: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firespin: ["9M"],
			flamecharge: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			fling: ["9M"],
			gigaimpact: ["9M"],
			heatwave: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lavaplume: ["9M"],
			lightscreen: ["9M"],
			nightshade: ["9M"],
			nightslash: ["9M"],
			overheat: ["9M"],
			phantomforce: ["9M"],
			poisonjab: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychocut: ["9M"],
			quickguard: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			shadowball: ["9M"],
			shadowclaw: ["9M"],
			shadowsneak: ["9M"],
			sleeptalk: ["9M"],
			solarblade: ["9M"],
			spite: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			throatchop: ["9M"],
			vacuumwave: ["9M"],
			willowisp: ["9M"],
			xscissor: ["9M"],
		},
	},
	bellibolt: {
		learnset: {
			acidspray: ["9M"],
			charge: ["9M"],
			chargebeam: ["9M"],
			chillingwater: ["9M"],
			confuseray: ["9M"],
			discharge: ["9M"],
			eerieimpulse: ["9M"],
			electricterrain: ["9M"],
			electroball: ["9M"],
			electroweb: ["9M"],
			endure: ["9M"],
			flail: ["9M"],
			gigaimpact: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			lightscreen: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			muddywater: ["9M"],
			paraboliccharge: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			slackoff: ["9M"],
			sleeptalk: ["9M"],
			soak: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			supercellslam: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			toxic: ["9M"],
			voltswitch: ["9M"],
			waterpulse: ["9M"],
			weatherball: ["9M"],
			wildcharge: ["9M"],
			zapcannon: ["9M"],
		},
	},
	scovillain: {
		learnset: {
			bite: ["9M"],
			bulletseed: ["9M"],
			burningjealousy: ["9M"],
			crunch: ["9M"],
			doublehit: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			fireblast: ["9M"],
			firefang: ["9M"],
			firespin: ["9M"],
			flamethrower: ["9M"],
			flareblitz: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			helpinghand: ["9M"],
			hyperbeam: ["9M"],
			ingrain: ["9M"],
			lashout: ["9M"],
			leafstorm: ["9M"],
			leechseed: ["9M"],
			overheat: ["9M"],
			protect: ["9M"],
			ragepowder: ["9M"],
			rest: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			spicyextract: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			superfang: ["9M"],
			swagger: ["9M"],
			temperflare: ["9M"],
			thief: ["9M"],
			thunderfang: ["9M"],
			trailblaze: ["9M"],
			willowisp: ["9M"],
			worryseed: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	espathra: {
		learnset: {
			aerialace: ["9M"],
			agility: ["9M"],
			allyswitch: ["9M"],
			babydolleyes: ["9M"],
			batonpass: ["9M"],
			bodyslam: ["9M"],
			bravebird: ["9M"],
			calmmind: ["9M"],
			confuseray: ["9M"],
			dazzlinggleam: ["9M"],
			doubleedge: ["9M"],
			drillpeck: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			featherdance: ["9M"],
			flashcannon: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			helpinghand: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			hypnosis: ["9M"],
			lastresort: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			luminacrash: ["9M"],
			mudslap: ["9M"],
			nightshade: ["9M"],
			pluck: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			quickattack: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roost: ["9M"],
			sandstorm: ["9M"],
			seedbomb: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			uturn: ["9M"],
			uproar: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	tinkaton: {
		learnset: {
			babydolleyes: ["9M"],
			brickbreak: ["9M"],
			brutalswing: ["9M"],
			bulldoze: ["9M"],
			covet: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fakeout: ["9M"],
			faketears: ["9M"],
			feint: ["9M"],
			flashcannon: ["9M"],
			flatter: ["9M"],
			fling: ["9M"],
			foulplay: ["9M"],
			gigatonhammer: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			icehammer: ["9M"],
			knockoff: ["9M"],
			lightscreen: ["9M"],
			metalsound: ["9M"],
			playrough: ["9M"],
			pounce: ["9M"],
			protect: ["9M"],
			quash: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			screech: ["9M"],
			skillswap: ["9M"],
			skittersmack: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sweetkiss: ["9M"],
			swordsdance: ["9M"],
			thief: ["9M"],
			thunderwave: ["9M"],
			woodhammer: ["9M"],
		},
	},
	palafin: {
		learnset: {
			acrobatics: ["9M"],
			agility: ["9M"],
			aquajet: ["9M"],
			aquatail: ["9M"],
			aurasphere: ["9M"],
			blizzard: ["9M"],
			bodyslam: ["9M"],
			boomburst: ["9M"],
			bounce: ["9M"],
			bulkup: ["9M"],
			charm: ["9M"],
			chillingwater: ["9M"],
			closecombat: ["9M"],
			counter: ["9M"],
			dive: ["9M"],
			doublehit: ["9M"],
			drainpunch: ["9M"],
			drainingkiss: ["9M"],
			encore: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			fling: ["9M"],
			flipturn: ["9M"],
			focusblast: ["9M"],
			focusenergy: ["9M"],
			focuspunch: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			hardpress: ["9M"],
			haze: ["9M"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			icebeam: ["9M"],
			icepunch: ["9M"],
			icywind: ["9M"],
			ironhead: ["9M"],
			jetpunch: ["9M"],
			liquidation: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			sleeptalk: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			taunt: ["9M"],
			throatchop: ["9M"],
			tickle: ["9M"],
			waterpulse: ["9M"],
			waterfall: ["9M"],
			wavecrash: ["9M"],
			whirlpool: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	orthworm: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			coil: ["9M"],
			curse: ["9M"],
			dig: ["9M"],
			doubleedge: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			heavyslam: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			irontail: ["9M"],
			metalburst: ["9M"],
			metalsound: ["9M"],
			mudshot: ["9M"],
			mudslap: ["9M"],
			protect: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			shedtail: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			spikes: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stompingtantrum: ["9M"],
			substitute: ["9M"],
			wrap: ["9M"],
		},
	},
	glimmora: {
		learnset: {
			acidarmor: ["9M"],
			acidspray: ["9M"],
			ancientpower: ["9M"],
			confuseray: ["9M"],
			dazzlinggleam: ["9M"],
			earthpower: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			explosion: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			gigaimpact: ["9M"],
			gunkshot: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			lightscreen: ["9M"],
			memento: ["9M"],
			meteorbeam: ["9M"],
			mortalspin: ["9M"],
			mudshot: ["9M"],
			powergem: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			rockblast: ["9M"],
			rockpolish: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandtomb: ["9M"],
			sandstorm: ["9M"],
			selfdestruct: ["9M"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M"],
			smackdown: ["9M"],
			solarbeam: ["9M"],
			spikes: ["9M"],
			spikyshield: ["9M"],
			stealthrock: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			toxic: ["9M"],
			toxicspikes: ["9M"],
			venoshock: ["9M"],
		},
	},
	farigiraf: {
		learnset: {
			agility: ["9M"],
			allyswitch: ["9M"],
			amnesia: ["9M"],
			assurance: ["9M"],
			batonpass: ["9M"],
			beatup: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			calmmind: ["9M"],
			chargebeam: ["9M"],
			confuseray: ["9M"],
			crunch: ["9M"],
			curse: ["9M"],
			dazzlinggleam: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			earthquake: ["9M"],
			endeavor: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			expandingforce: ["9M"],
			facade: ["9M"],
			foulplay: ["9M"],
			futuresight: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			gravity: ["9M"],
			guardswap: ["9M"],
			helpinghand: ["9M"],
			highhorsepower: ["9M"],
			hyperbeam: ["9M"],
			hypervoice: ["9M"],
			imprison: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			lowkick: ["9M"],
			meanlook: ["9M"],
			mirrorcoat: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			powerswap: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			psychic: ["9M"],
			psychicfangs: ["9M"],
			psychicnoise: ["9M"],
			psychicterrain: ["9M"],
			psyshock: ["9M"],
			raindance: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			shadowball: ["9M"],
			skillswap: ["9M"],
			sleeptalk: ["9M"],
			stompingtantrum: ["9M"],
			storedpower: ["9M"],
			substitute: ["9M"],
			sunnyday: ["9M"],
			thief: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
			trailblaze: ["9M"],
			trick: ["9M"],
			trickroom: ["9M"],
			twinbeam: ["9M"],
			uproar: ["9M"],
			wish: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	kingambit: {
		learnset: {
			aerialace: ["9M"],
			airslash: ["9M"],
			assurance: ["9M"],
			brickbreak: ["9M"],
			darkpulse: ["9M"],
			dig: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			fling: ["9M"],
			focusblast: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			guillotine: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			kowtowcleave: ["9M"],
			lashout: ["9M"],
			lowkick: ["9M"],
			lowsweep: ["9M"],
			meanlook: ["9M"],
			metalburst: ["9M"],
			metalsound: ["9M"],
			nightslash: ["9M"],
			poisonjab: ["9M"],
			protect: ["9M"],
			quickguard: ["9M"],
			raindance: ["9M"],
			rest: ["9M"],
			reversal: ["9M"],
			rocktomb: ["9M"],
			sandstorm: ["9M"],
			scaryface: ["9M"],
			shadowclaw: ["9M"],
			sleeptalk: ["9M"],
			snarl: ["9M"],
			spite: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			swordsdance: ["9M"],
			taunt: ["9M"],
			thief: ["9M"],
			throatchop: ["9M"],
			thunderwave: ["9M"],
			torment: ["9M"],
			xscissor: ["9M"],
			zenheadbutt: ["9M"],
		},
	},
	sinistcha: {
		learnset: {
			calmmind: ["9M"],
			curse: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			foulplay: ["9M"],
			gigadrain: ["9M"],
			grassyterrain: ["9M"],
			hex: ["9M"],
			hyperbeam: ["9M"],
			imprison: ["9M"],
			irondefense: ["9M"],
			leafstorm: ["9M"],
			lifedew: ["9M"],
			matchagotcha: ["9M"],
			memento: ["9M"],
			nastyplot: ["9M"],
			nightshade: ["9M"],
			painsplit: ["9M"],
			phantomforce: ["9M"],
			poltergeist: ["9M"],
			protect: ["9M"],
			psychup: ["9M"],
			ragepowder: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			scald: ["9M"],
			shadowball: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			spite: ["9M"],
			strengthsap: ["9M"],
			stunspore: ["9M"],
			substitute: ["9M"],
			trickroom: ["9M"],
			uproar: ["9M"],
		},
	},
	sinistchamasterpiece: {},
	archaludon: {
		learnset: {
			aurasphere: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			brickbreak: ["9M"],
			darkpulse: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonclaw: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthquake: ["9M"],
			electroshot: ["9M"],
			endure: ["9M"],
			facade: ["9M"],
			flashcannon: ["9M"],
			focusenergy: ["9M"],
			foulplay: ["9M"],
			gigaimpact: ["9M"],
			gyroball: ["9M"],
			hardpress: ["9M"],
			heavyslam: ["9M"],
			hyperbeam: ["9M"],
			irondefense: ["9M"],
			ironhead: ["9M"],
			lightscreen: ["9M"],
			metalburst: ["9M"],
			metalsound: ["9M"],
			meteorbeam: ["9M"],
			mirrorcoat: ["9M"],
			nightslash: ["9M"],
			outrage: ["9M"],
			protect: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			roar: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			scaryface: ["9M"],
			sleeptalk: ["9M"],
			smackdown: ["9M"],
			snarl: ["9M"],
			solarbeam: ["9M"],
			stealthrock: ["9M"],
			steelbeam: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			swordsdance: ["9M"],
			thunder: ["9M"],
			thunderwave: ["9M"],
			thunderbolt: ["9M"],
		},
	},
	hydrapple: {
		learnset: {
			bodypress: ["9M"],
			bodyslam: ["9M"],
			breakingswipe: ["9M"],
			bugbite: ["9M"],
			bulletseed: ["9M"],
			curse: ["9M"],
			doublehit: ["9M"],
			doubleedge: ["9M"],
			dracometeor: ["9M"],
			dragoncheer: ["9M"],
			dragonpulse: ["9M"],
			dragontail: ["9M"],
			earthpower: ["9M"],
			earthquake: ["9M"],
			endure: ["9M"],
			energyball: ["9M"],
			facade: ["9M"],
			ficklebeam: ["9M"],
			gigadrain: ["9M"],
			gigaimpact: ["9M"],
			grassknot: ["9M"],
			grassyglide: ["9M"],
			grassyterrain: ["9M"],
			growth: ["9M"],
			gyroball: ["9M"],
			heavyslam: ["9M"],
			hydropump: ["9M"],
			hyperbeam: ["9M"],
			infestation: ["9M"],
			leafstorm: ["9M"],
			nastyplot: ["9M"],
			outrage: ["9M"],
			pollenpuff: ["9M"],
			pounce: ["9M"],
			powerwhip: ["9M"],
			protect: ["9M"],
			raindance: ["9M"],
			recover: ["9M"],
			recycle: ["9M"],
			reflect: ["9M"],
			rest: ["9M"],
			seedbomb: ["9M"],
			sleeptalk: ["9M"],
			solarbeam: ["9M"],
			substitute: ["9M"],
			suckerpunch: ["9M"],
			sunnyday: ["9M"],
			sweetscent: ["9M"],
			syrupbomb: ["9M"],
			uproar: ["9M"],
			yawn: ["9M"],
		},
	},
};
